var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWrite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.988 3.387 2.132 14.243a.7.7 0 0 0-.178.312l-.932 3.589a.685.685 0 0 0 .662.856.7.7 0 0 0 .172-.022l3.59-.932a.7.7 0 0 0 .311-.178L16.613 7.012V7.01L18.8 4.826a.684.684 0 0 0 0-.968L16.144 1.2a.684.684 0 0 0-.968 0L12.99 3.386zM5 17.3l-3 .78.779-3z"
})));
export default SvgWrite;